
const fetchProductCardHTML = (handle) => {
    return fetch(`/products/${handle}?view=card`)
        .then((res) => res.text())
        .then((res) => {
            const text = res;
            const parser = new DOMParser();
            const htmlDocument = parser.parseFromString(text, 'text/html');
            const productCardWrapper = document.createElement('div');
            productCardWrapper.className = "grid__item";
            const productCard = htmlDocument.documentElement.querySelector('.product-card');
            productCardWrapper.appendChild(productCard);
            return productCardWrapper.outerHTML;
        })
        .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

async function createWishlistCards(result) {
    let productHandles = [];
    result.forEach(item => {
        productHandles.push(item.handle)
    })
    const requests = productHandles.map(fetchProductCardHTML);
    const responses = await Promise.all(requests);
    const wishlistProductCards = responses.join('');
    document.querySelector('#wishlist-container').innerHTML = wishlistProductCards;
}

if (window.CUSTOMER && window.CUSTOMER.id) {
    const url = `https://api.myshopapps.com/wishlist/V2/${"fetchWishlistData/" + window.CUSTOMER.id}`;
    const options = {
        method: 'GET',
        headers: {
            xtoken: 'IWISH_API_b157cba76dbe11ef96ef0e72f2521631',
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json'
        }
    };

    try {
        const response = await fetch(url, options);
        const data = await response.json();
        console.log("success")
        localStorage.setItem('iWishlistmain', JSON.stringify(data.result))
        if (document.querySelector('#wishlist-container')) createWishlistCards(data.result);
        if (data.result.length > 0) {
            console.log('yes')
            document.querySelector('.header__nav-icon-wish-span').removeAttribute('hidden');
            document.querySelector('.header__nav-icon-wish-span').innerHTML = data.result.length;
        } else {
            console.log('no')
            document.querySelector('.header__nav-icon-wish-span').setAttribute('hidden', '')
        }
    } catch (error) {
        console.error(error);
    }
} else {
    if (JSON.parse(localStorage.getItem('iWishlistmainNotLoggedin')) && JSON.parse(localStorage.getItem('iWishlistmainNotLoggedin')).length > 0) {
        if (document.querySelector('#wishlist-container')) createWishlistCards(JSON.parse(localStorage.getItem('iWishlistmainNotLoggedin')));
        document.querySelector('.header__nav-icon-wish-span').removeAttribute('hidden');
        document.querySelector('.header__nav-icon-wish-span').innerHTML = JSON.parse(localStorage.getItem('iWishlistmainNotLoggedin')).length
    } else {
        document.querySelector('.header__nav-icon-wish-span').setAttribute('hidden', '')
    }

}

class WishHeart extends HTMLElement {
    constructor() {
        super();
        this.banner = this.closest("product-card")?.querySelector('.add-to-wish-banner');
        this.spanNumber = document.querySelector('.header__nav-icon-wish-span');
        this.init();
    }

    showBanner() {
        if (this.banner) {
            this.banner.style.display = "block";
            setTimeout(() => {
                this.banner.style.display = "none";
            }, 3000)
        }
    }
    async handleFetchAdd(product_id, variant_id) {
        const url = `https://api.myshopapps.com/wishlist/V2/addToWishlist`;
        const options = {
          method: 'POST',
          headers: {
            xtoken: 'IWISH_API_b157cba76dbe11ef96ef0e72f2521631',
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json',
          },
          body: new URLSearchParams({
            customer_id: window.CUSTOMER.id,
            product_id,
            variant_id,
          }),
        };

        try {
            const response = await fetch(url, options);
            const data = await response.json();
            console.log("added")
        } catch (error) {
            console.error(error);
        }
    }
    async handleFetchRemove(variant_id) {
        const url = `https://api.myshopapps.com/wishlist/V2/removeWishlist?customer_id=${window.CUSTOMER.id}&variant_id=${variant_id}`;
        const options = {
          method: 'DELETE',
          headers: {
            xtoken: 'IWISH_API_b157cba76dbe11ef96ef0e72f2521631',
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json',
          }
        };

        try {
            const response = await fetch(url, options);
            const data = await response.json();
            console.log("removed")
        } catch (error) {
            console.error(error);
        }
    }

    handleAddLocalStorage() {
        const localStorageData = JSON.parse(localStorage.getItem('iWishlistmainNotLoggedin'));
        const newItem = {
            id: this.dataset.productId,
            handle: this.dataset.handle
        }
        let newLocalStorageData = []
        localStorageData ? newLocalStorageData = localStorageData.concat(newItem) : newLocalStorageData = [newItem]
        localStorage.setItem("iWishlistmainNotLoggedin", JSON.stringify(newLocalStorageData))
    }

    handleRemoveLocalStorage() {
        const localStorageData = JSON.parse(localStorage.getItem('iWishlistmainNotLoggedin'));
        const updatedArray = localStorageData.filter((obj) => obj.id != this.dataset.productId);
        localStorage.setItem('iWishlistmainNotLoggedin', JSON.stringify(updatedArray))
    }

    addToWishlistEvent() {
        this.removeEventListener('click', this.handleRemoveFromWishlist);
        this.addEventListener('click', this.handleAddToWishlist);
    }

    removeToWishlistEvent() {
        this.removeEventListener('click', this.handleAddToWishlist);
        this.addEventListener('click', this.handleRemoveFromWishlist);
    }

    handleAddToWishlist = () => {
        window.CUSTOMER && window.CUSTOMER.id ? this.handleFetchAdd(Number(this.dataset.productId), Number(this.dataset.variantId)) : this.handleAddLocalStorage();
        if (this.closest('.wish-heart_product-info')) {
          document.querySelectorAll(`wish-heart[data-handle="${this.getAttribute('data-handle')}"]`).forEach(heart => heart.querySelector('svg').style.fill = "#fff" )
        } else {
          document.querySelectorAll(`wish-heart[data-handle="${this.getAttribute('data-handle')}"]`).forEach(heart => heart.querySelector('svg').style.fill = "rgb(13 13 45)" )
        }
        this.spanNumber.innerText = Number(this.spanNumber.innerText) + 1
        if (this.spanNumber.innerText != '0') document.querySelector('.header__nav-icon-wish-span').removeAttribute('hidden')
        this.showBanner();
        this.removeToWishlistEvent();
    };

    handleRemoveFromWishlist = () => {
        window.CUSTOMER && window.CUSTOMER.id ? this.handleFetchRemove(Number(this.dataset.variantId)) : this.handleRemoveLocalStorage();
        if (this.closest('.wish-heart_product-info')) {
          document.querySelectorAll(`wish-heart[data-handle="${this.getAttribute('data-handle')}"]`).forEach(heart => heart.querySelector('svg').style.fill = "rgb(13 13 45)" )
        } else {
+          document.querySelectorAll(`wish-heart[data-handle="${this.getAttribute('data-handle')}"]`).forEach(heart => heart.querySelector('svg').style.fill = "none" )
        }
        this.spanNumber.innerText = Number(this.spanNumber.innerText) - 1
        if (this.spanNumber.innerText == '0') document.querySelector('.header__nav-icon-wish-span').setAttribute('hidden', '')
        if (this.banner) this.banner.style.display = "none";
        if (document.querySelector('#wishlist-container')) this.closest('.grid__item').remove();
        this.addToWishlistEvent();
    };

    init() {
        const iWishlistmain = window.CUSTOMER && window.CUSTOMER.id ? localStorage.getItem('iWishlistmain') : localStorage.getItem('iWishlistmainNotLoggedin');
        if (iWishlistmain && JSON.parse(iWishlistmain).some(obj => obj.id === this.dataset.productId)) {
            this.removeToWishlistEvent();
            this.querySelector('svg').style.fill = "rgb(13 13 45)";
            this.querySelector('svg.product-wish') ? this.querySelector('svg.product-wish').style.fill = "#fff" : null;
        } else {
            this.addToWishlistEvent();
            this.querySelector('svg').style.fill = "none";
        }
    }
}

customElements.define('wish-heart', WishHeart);
